import React, { useState } from "react";

import { ChevronDown } from "lucide-react";

const OrderVendorsAction = ({
  showAddVendor,

  closeAddVendor,

  openCategory,

  setOpenCategory,

  form,

  setForm,

  handleAddVendor,

  VENDOR_TYPES,

  PRODUCT_CATEGORIES,

  showAddPurchase,

  closeAddPurchase,

  vendorNameInput,

  setVendorNameInput,

  amount,

  setAmount,

  desc,

  setDesc,

  date,

  setDate,

  paymentMode,

  setPaymentMode,

  handleAddPurchase,

  vendors,

  selectedVendor,

  setSelectedVendor,

  showVendorPurchase,

  closeVendorPurchase,

  handleVendorPurchase,

  showEditVendor,

  closeEditVendor,

  handleEditVendor,

  showPayModal,

  selectedPurchase,

  closePayModal,

  handleConfirmPayment,

  isPaymentProcessing,
}) => {
  const [showVendorDropdown, setShowVendorDropdown] = useState(false);

  const [vendorSearch, setVendorSearch] = useState("");

  const [openVendorType, setOpenVendorType] = useState(false);

  const [openEditVendorType, setOpenEditVendorType] = useState(false);

  const filteredVendors = vendors.filter((v) =>
    (v.vendorName || "")

      .toLowerCase()

      .includes(vendorSearch.toLowerCase()),
  );

  return (
    <>
      {/* Add vendor Modal */}

      {showAddVendor && (
        <div className="fixed inset-0 bg-black/30 flex justify-center montserrat-font-1 items-center z-50 p-4">
          <div className="bg-white w-full max-w-[520px] max-h-[90vh] montserrat-font-1  overflow-y-auto rounded-xl shadow-lg">
            <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-white z-[999]">
              <h2 className="text-sm font-semibold">Add Vendor</h2>

              <button
                onClick={closeAddVendor}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-6 grid grid-cols-2 gap-4">
              <div className="col-span-2">
                <label className="text-xs font-medium text-gray-600">
                  Vendor Name <span className="text-red-500">*</span>
                </label>

                <input
                  value={form.vendorName}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, vendorName: e.target.value }))
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div className="relative">
                <label className="text-xs font-medium text-gray-600">
                  Vendor Type
                </label>

                <div
                  onClick={() => setOpenVendorType(!openVendorType)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
                >
                  {form.vendorType || "Select Vendor Type"}

                  <ChevronDown
                    size={18}
                    className={`text-gray-400 transition-transform duration-200 ${
                      openVendorType ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {openVendorType && (
                  <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {VENDOR_TYPES.map((type) => (
                      <div
                        key={type}
                        onClick={() => {
                          setForm({
                            ...form,

                            vendorType: type,
                          });

                          setOpenVendorType(false);
                        }}
                        className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        {type}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <div className="relative">
                  <label className="text-xs font-medium text-gray-600">
                    Product Category
                  </label>

                  <div
                    onClick={() => setOpenCategory(!openCategory)}
                    className="mt-1 w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
                  >
                    {form.vendorCategory || "Select Product Category"}

                    <ChevronDown
                      size={18}
                      className={`text-gray-400 transition-transform duration-200 ${
                        openCategory ? "rotate-180" : ""
                      }`}
                    />
                  </div>

                  {openCategory && (
                    <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                      {PRODUCT_CATEGORIES.map((cat) => (
                        <div
                          key={cat}
                          onClick={() => {
                            setForm({
                              ...form,

                              vendorCategory: cat,
                            });

                            setOpenCategory(false);
                          }}
                          className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                        >
                          {cat}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-span-2">
                <label className="text-xs font-medium text-gray-600">
                  Address
                </label>

                <textarea
                  value={form.vendorAddress}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,

                      vendorAddress: e.target.value,
                    }))
                  }
                  rows={3}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">GST</label>

                <input
                  value={form.gst}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, gst: e.target.value }))
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Mobile
                </label>

                <input
                  value={form.mobile}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, mobile: e.target.value }))
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  State
                </label>

                <input
                  value={form.state}
                  onChange={(e) => setForm({ ...form, state: e.target.value })}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  City
                </label>

                <input
                  value={form.city}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, city: e.target.value }))
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Account Number
                </label>

                <input
                  value={form.accountNumber}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,

                      accountNumber: e.target.value,
                    }))
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  IFSC Code
                </label>

                <input
                  placeholder="e.g., HDFC0001234"
                  value={form.ifscCode}
                  onChange={(e) =>
                    setForm({ ...form, ifscCode: e.target.value })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 px-6 py-4 border-t">
              <button
                onClick={closeAddVendor}
                className="px-4 py-2 border rounded-lg text-sm bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleAddVendor}
                className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Purchase model for new vendor  */}

      {showAddPurchase && (
        <div className="fixed inset-0 bg-black/30 flex justify-center items-center montserrat-font-1 z-50 p-4">
          <div className="bg-white montserrat-font-1  w-full max-w-[520px] max-h-[90vh] overflow-y-auto rounded-xl shadow-lg">
            <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-white z-[999]">
              <h2 className="text-sm font-semibold">Add Purchase</h2>

              <button
                onClick={closeAddPurchase}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-medium text-gray-600">
                  Vendor Name <span className="text-red-500">*</span>
                </label>

                <input
                  placeholder="Enter vendor name"
                  value={vendorNameInput}
                  onChange={(e) => setVendorNameInput(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Amount <span className="text-red-500">*</span>
                </label>

                <input
                  type="number"
                  placeholder="e.g., 1500 or 1500.50"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Description
                </label>

                <textarea
                  placeholder="Optional purchase description"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  rows={3}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Purchase Date <span className="text-red-500">*</span>
                </label>

                <div className="relative">
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Payment Mode <span className="text-red-500">*</span>
                </label>

                <select
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                >
                  <option value="cash">Cash</option>

                  <option value="imps">IMPS/Bank Transfer</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end gap-3 px-5 py-4 border-t">
              <button
                onClick={closeAddPurchase}
                className="px-4 py-2 rounded-lg border text-sm bg-gray-100 hover:bg-gray-200"
              >
                Cancel
              </button>

              <button
                onClick={handleAddPurchase}
                className="flex items-center gap-1 px-4 py-2 rounded-lg bg-green-600 text-white text-sm hover:bg-green-700"
              >
                ₹ Add Purchase
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Purchase model for table */}

      {showVendorPurchase && selectedVendor && (
        <div className="fixed inset-0 bg-black/30 montserrat-font-1 flex justify-center items-center z-50">
          <div className="bg-white w-[420px] rounded-xl montserrat-font-1 shadow-lg">
            <div className="flex justify-between items-center px-5 py-4 border-b">
              <h2 className="text-sm font-semibold">Add Purchase</h2>

              <button
                onClick={closeVendorPurchase}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-medium text-gray-600">
                  Vendor <span className="text-red-500">*</span>
                </label>

                <div className="relative mt-1">
                  <div
                    onClick={() => setShowVendorDropdown((prev) => !prev)}
                    className="w-full border rounded-lg px-3 py-2 text-sm cursor-pointer bg-white flex justify-between items-center"
                  >
                    <span>{selectedVendor?.vendorName || "Select Vendor"}</span>

                    <span className="text-gray-500">▼</span>
                  </div>

                  {showVendorDropdown && (
                    <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg">
                      <div className="max-h-48 overflow-y-auto">
                        {filteredVendors.length > 0 ? (
                          filteredVendors.map((v) => (
                            <div
                              key={v.id}
                              onClick={() => {
                                setSelectedVendor(v);

                                setVendorSearch("");

                                setShowVendorDropdown(false);
                              }}
                              className="px-3 py-2 cursor-pointer hover:bg-green-50"
                            >
                              {v.vendorName}
                            </div>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-gray-500 text-sm">
                            No vendors found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Amount <span className="text-red-500">*</span>
                </label>

                <input
                  type="number"
                  placeholder="e.g., 1500 or 1500.50"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Description
                </label>

                <textarea
                  placeholder="Optional purchase description"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Purchase Date <span className="text-red-500">*</span>
                </label>

                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 px-5 py-4 border-t">
              <button
                onClick={closeVendorPurchase}
                className="px-4 py-2 rounded-lg border text-sm bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleVendorPurchase}
                className="flex items-center gap-1 px-4 py-2 rounded-lg bg-green-600 text-white text-sm hover:bg-green-700"
              >
                ₹ Add Purchase
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit vendor Modal */}

      {showEditVendor && selectedVendor && (
        <div className="fixed inset-0 bg-black/30 montserrat-font-1 flex justify-center items-center z-50 p-4">
          <div className="bg-white montserrat-font-1 w-full max-w-[520px] max-h-[90vh] overflow-y-auto rounded-xl shadow-lg">
            <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-white z-[999]">
              <h2 className="text-sm font-semibold">Edit Vendor</h2>

              <button
                onClick={closeEditVendor}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-6 grid grid-cols-2 gap-4">
              <div className="col-span-2">
                <label className="text-xs font-medium text-gray-600">
                  Vendor Name <span className="text-red-500">*</span>
                </label>

                <input
                  value={selectedVendor.vendorName}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      vendorName: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 outline-none"
                />
              </div>

              <div className="relative">
                <label className="text-xs font-medium text-gray-600">
                  Vendor Type
                </label>

                <div
                  onClick={() => setOpenEditVendorType(!openEditVendorType)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
                >
                  {selectedVendor.vendorType || "Select Vendor Type"}

                  <ChevronDown
                    size={18}
                    className={`text-gray-400 transition-transform duration-200 ${
                      openEditVendorType ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {openEditVendorType && (
                  <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {VENDOR_TYPES.map((type) => (
                      <div
                        key={type}
                        onClick={() => {
                          setSelectedVendor({
                            ...selectedVendor,

                            vendorType: type,
                          });

                          setOpenEditVendorType(false);
                        }}
                        className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        {type}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="text-xs font-medium text-gray-600">
                  Product Category
                </label>

                <div
                  onClick={() => setOpenCategory(!openCategory)}
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
                >
                  {selectedVendor.vendorCategory || "Select Category"}

                  <ChevronDown
                    size={18}
                    className={`text-gray-400 transition-transform duration-200 ${
                      openCategory ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {openCategory && (
                  <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {PRODUCT_CATEGORIES.map((cat) => (
                      <div
                        key={cat}
                        onClick={() => {
                          setSelectedVendor({
                            ...selectedVendor,

                            vendorCategory: cat,
                          });

                          setOpenCategory(false);
                        }}
                        className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        {cat}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="col-span-2">
                <label className="text-xs font-medium text-gray-600">
                  Address
                </label>

                <textarea
                  value={selectedVendor.vendorAddress}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      vendorAddress: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">GST</label>

                <input
                  value={selectedVendor.gst}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      gst: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Mobile
                </label>

                <input
                  value={selectedVendor.mobile}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      mobile: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  State
                </label>

                <input
                  value={selectedVendor.state}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      state: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  City
                </label>

                <input
                  value={selectedVendor.city}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      city: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Account Number
                </label>

                <input
                  placeholder="e.g., 012345678901"
                  value={selectedVendor.account_number}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      account_number: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  IFSC Code
                </label>

                <input
                  placeholder="e.g., HDFC0001234"
                  value={selectedVendor.ifsc}
                  onChange={(e) =>
                    setSelectedVendor({
                      ...selectedVendor,

                      ifsc: e.target.value,
                    })
                  }
                  className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 px-6 py-4 border-t">
              <button
                onClick={closeEditVendor}
                className="px-4 py-2 border rounded-lg text-sm bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={handleEditVendor}
                className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {/* pay purchase model */}

      {showPayModal && selectedPurchase && (
        <div className="fixed inset-0 bg-black/30 flex justify-center montserrat-font-1 items-center z-50">
          <div className="bg-white w-[420px] rounded-xl montserrat-font-1 shadow-lg">
            <div className="flex justify-between items-center px-5 py-4 border-b">
              <h2 className="text-sm font-semibold">Pay / Settle Purchase</h2>

              <button
                onClick={closePayModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-medium text-gray-600">
                  Vendor
                </label>

                <div className="mt-1 border rounded-lg px-3 py-2 text-sm bg-gray-50">
                  {selectedPurchase.vendor_name} (Vendor ID:{" "}
                  {selectedPurchase.fk_vendor_id})
                </div>
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Purchase ID
                </label>

                <div className="mt-1 border rounded-lg px-3 py-2 text-sm bg-gray-50">
                  {selectedPurchase.id}
                </div>
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Amount
                </label>

                <div className="mt-1 border rounded-lg px-3 py-2 text-sm bg-gray-50 flex items-center gap-1">
                  <span>₹</span>

                  {selectedPurchase.amount}
                </div>
              </div>

              <div>
                <label className="text-xs font-medium text-gray-600">
                  Mode
                </label>

                <div className="mt-1 border rounded-lg px-3 py-2 text-sm bg-gray-50 uppercase">
                  {paymentMode}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 px-5 py-4 border-t">
              <button
                onClick={closePayModal}
                className="px-4 py-2 rounded-lg border bg-gray-100 text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleConfirmPayment}
                disabled={isPaymentProcessing}
                className={`flex items-center gap-1 px-4 py-2 rounded-lg text-white text-sm ${
                  isPaymentProcessing
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                ₹{" "}
                {isPaymentProcessing
                  ? "Processing..."
                  : paymentMode === "cash"
                    ? "Confirm Cash"
                    : "Pay (IMPS)"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderVendorsAction;
